import AuthorisedRoute from './authorised-route';
export default AuthorisedRoute;
